// v-if、v-show 与 v-admin 冲突
// v-if="you_condition && checkPermission('you_permission')"
// v-admin="'you_permission'"
import store from '@/store'

export default function (permission) {
  if (!store.state.auth.user) {
    return false
  }
  if (!permission || store.state.auth.user.is_supper_admin || store.state.auth.user.permissions.indexOf(permission) >= 0) {
    return true
  }
  return false
}
